<!--
 * @Author: Niklaus
 * @Date: 2026-04-08 15:09:54
 * @LastEditTime: 2026-04-14 14:30:11
 * @LastEditors: Niklaus
 * @Description: 
-->
<template>
    <div>
        <TripartiteAgreementForm v-if="contractInfo.supplementary_type == 1" :id="id" mode='view'>
        </TripartiteAgreementForm>
        <!-- 终止协议 -->
        <TerminationForm v-else-if="contractInfo.supplementary_type == 2" :contractInfo="contractInfo" :id="id"
            mode='view'></TerminationForm>
        <!-- 合同变更 -->
        <ContractReletForm v-else-if="contractInfo.supplementary_type == 3" :contractInfo="contractInfo" :id="id"
            mode='view'></ContractReletForm>
        <!-- 租赁费另签 -->
        <ZqfylqForm v-else-if="contractInfo.supplementary_type == 4" :contractInfo="contractInfo" :id="id" mode='view'>
        </ZqfylqForm>
    </div>
</template>

<script>
import ZqfylqForm from "./zqfylqForm.vue"
import ContractReletForm from "./contractReletForm.vue"
import TerminationForm from "./terminationForm.vue"
import TripartiteAgreementForm from "./tripartiteAgreementForm.vue"

import { supplementaryDetail } from "@/api/contract/index.js"
import { getMetaCommonDetail, getPicListByIds } from "@/api/busiMode/metaCommon"

export default {
    provide() {
        return {
            supplementarysIndex: this,
        }
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "",
        },
    },
    components: { TripartiteAgreementForm, ZqfylqForm, ContractReletForm, TerminationForm },

    data() {
        return {
            contractInfo: {}
        }
    },

    mounted() {
        console.log(this.id)
        this.getDetail()
    },

    methods: {
        getDetail() {
            getMetaCommonDetail('wisdom_park.wp_contract_supplementary', {
                pk: 'id',
                id: this.id,
            }).then((res) => {
                // supplementaryDetail({
                //     id: this.id,
                // }).then((res) => {
                console.log(res)
                this.contractInfo = res.data.data
            })
        }
    },
}
</script>